/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/require-default-props */
import React from 'react';
import Select from 'react-select';
import { ManagementMember } from 'store/modules/management_store/types';

interface AffectedMembersSelectProps {
  active: Array<ManagementMember>;
  inactive: Array<ManagementMember>;
  value: Array<number>;
  onChange: (memberIds: Array<number>) => void;
  currentUserId: number;
  isLoading?: boolean;
}

interface MemberOption {
  value: number;
  label: string;
}

const AffectedMembersSelect: React.FC<AffectedMembersSelectProps> = ({
  active,
  inactive,
  value,
  onChange,
  currentUserId,
  isLoading = false,
}) => {
  const toOption = (member: ManagementMember): MemberOption => ({
    value: member.id,
    label: member.id === currentUserId ? `${member.nome} (você)` : member.nome,
  });
  const activeOptions = active.map(toOption);
  const inactiveOptions = inactive.map(toOption);
  const selected = [...activeOptions, ...inactiveOptions].filter((option) =>
    value.includes(option.value),
  );

  return (
    <div className="mb-3">
      <label htmlFor="AffectedMembersSelect" className="font-weight-bold">
        Quem será afetado?
      </label>
      <Select
        inputId="AffectedMembersSelect"
        isMulti
        isSearchable
        isLoading={isLoading}
        closeMenuOnSelect={false}
        options={[
          { label: 'Ativos', options: activeOptions },
          { label: 'Inativos', options: inactiveOptions },
        ]}
        value={selected}
        onChange={(options) => onChange(options.map((option) => option.value))}
        placeholder="Selecione os membros"
        noOptionsMessage={() => 'Nenhum membro encontrado'}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 3000000001 }) }} // Para visualizar componente acima da modal
      />
    </div>
  );
};

export default AffectedMembersSelect;
